import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { useVirtual } from 'react-virtual';
export function useVirtualized(props) {
    var estimate = props.estimate, items = props.items, renderElement = props.renderElement, _a = props.focusedIndex, focusedIndex = _a === void 0 ? null : _a;
    var containerRef = useRef(null);
    var estimateSize = useCallback(function (index) {
        return typeof estimate === 'number' ? estimate : estimate(items[index]);
    }, [estimate, items]);
    var virtualizer = useVirtual({
        size: items.length,
        parentRef: containerRef,
        estimateSize: estimateSize,
    });
    useEffect(function () {
        if (focusedIndex !== null) {
            virtualizer.scrollToIndex(focusedIndex, { align: 'auto' });
        }
    }, [focusedIndex, items.length, estimate]);
    return {
        innerProps: {
            style: {
                position: 'relative',
                height: virtualizer.totalSize,
            },
        },
        containerProps: {
            style: {
                overflowY: 'auto',
            },
            ref: containerRef,
        },
        virtualItems: virtualizer.virtualItems.map(function (item) { return (React.createElement(Fragment, { key: item.key }, renderElement({
            element: items[item.index],
            style: {
                transform: "translateY(" + item.start + "px)",
                position: 'absolute',
                top: 0,
                left: 0,
            },
        }))); }),
    };
}
